import { PocTypography } from 'commons/components/components-wrapper';
import React from 'react';
import { CopyButtonComponent } from '../copy-button/copy-button.component';
import { ValueButton } from '../value-button/value-button.style';
import { LayoutDetailFieldComponent } from './detail-field.style';

export interface DetailFieldComponentProps {
    label: string;
    value?: string | null;
    hoverable?: boolean;
    valueToCopy?: string;
    labelClassname?: string;
    valueClassname?: string;
    onClickValue?: () => void;
}

export const DetailFieldComponent: React.FC<DetailFieldComponentProps> = (props) => {
    const {
        label,
        value,
        valueToCopy,
        hoverable = false,
        labelClassname = '',
        valueClassname = '',
        onClickValue,
    } = props;

    const valueText = (
        <PocTypography className={valueClassname} element="span" variant="body1">
            {value}
        </PocTypography>
    );

    return (
        <LayoutDetailFieldComponent clickableValue={!!onClickValue} hoverable={hoverable}>
            <div className="content">
                <PocTypography className={labelClassname} element="p" variant="subtitle2">{`${label}:`}</PocTypography>
                {onClickValue ? (
                    <ValueButton type="button" onClick={onClickValue}>
                        {valueText}
                    </ValueButton>
                ) : (
                    valueText
                )}
            </div>
            {valueToCopy ? <CopyButtonComponent valueToCopy={valueToCopy} /> : undefined}
        </LayoutDetailFieldComponent>
    );
};
